import { ReactNode, useEffect } from 'react';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { HelpAssistant } from '@/components/support/HelpAssistant';
import { useAuthStore } from '@/stores/useAuthStore';

// Importar script de migração para torná-lo disponível globalmente
import '@/scripts/migrateBadgesForExistingUsers';

interface MainLayoutProps {
  children: ReactNode;
  showBottomNav?: boolean;
}

export function MainLayout({ children, showBottomNav = true }: MainLayoutProps) {
  const { isAuthenticated, user } = useAuthStore();
  
  // ✅ OTIMIZADO: Badge checker removido (agora executado condicionalmente via useBadgeCheckerOptimized)

  // Log informativo sobre o script de migração (apenas para admins em dev)
  useEffect(() => {
    if (isAuthenticated && user && import.meta.env.DEV) {
      console.log('💡 Script de migração de badges disponível!');
      console.log('📝 Execute no console: await window.migrateBadges()');
    }
  }, [isAuthenticated, user]);

  return (
    <div className="relative min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      {isAuthenticated && showBottomNav && <BottomNav />}
      {isAuthenticated && <HelpAssistant />}
    </div>
  );
}
